import { render, staticRenderFns } from "./EconomicGroupSelectClients.vue?vue&type=template&id=4050d7fe"
import script from "./EconomicGroupSelectClients.vue?vue&type=script&lang=js"
export * from "./EconomicGroupSelectClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports